module.exports = __webpack_public_path__ + "img/iphone-feature-bg-01.f6b08c11.svg";